import { PageSetup } from 'exceljs';
export const pageSetup: Partial<PageSetup> = {
  paperSize: 9,
  orientation: 'landscape',
  margins: {
    left: 0.5,
    right: 0.5,
    top: 1,
    bottom: 0.5,
    header: 0.3,
    footer: 0.1
  }
};

export const generateOvenSettingsTableData = (description: string): Record<string, string> => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(description, 'text/html');

  const rowData = [...doc.querySelectorAll('tr')].map((row) => {
    const cells = [...row.querySelectorAll('td')].map((cell) => cell.textContent ?? '');
    return cells;
  });

  const tableData: Record<string, string> = {};

  for (const row of rowData) {
    if (row.length === 2) {
      const attributeName = row[0].trim();
      const attributeValue = row[1].trim() ?? '';
      tableData[attributeName] = attributeValue;
    }
  }

  return tableData;
};
